/**
 * 全屏加载组件
 */

import { motion } from 'framer-motion';

export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center z-50">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className="text-center"
      >
        <div className="loader mx-auto mb-4"></div>
        <p className="text-primary-700 font-medium">加载中...</p>
      </motion.div>
    </div>
  );
}